module.exports = __webpack_public_path__ + "img/yaamava-bg.31efc420.jpg";